// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5e69d852","header":"_e51411e","message":"_fc03368a"};